import theme from '../../theme'

export const defaultStyle = {
  backgroundColor: theme.blue,
  border: `1px solid ${theme.blue}`,
  borderRadius: 1,
  color: 'white',
  fontFamily: theme.primaryFont,
  fontSize: '1.125rem',
  lineHeight: '0.89',
  padding: '20px 26px',
  textDecoration: 'none',
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': {
    boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.3)',
    backgroundColor: theme.darkBlue,
    border: `1px solid ${theme.blue}`,
  },
}

export const invertedStyle = {
  backgroundColor: 'white',
  border: 'solid',
  borderColor: 'white',
  borderRadius: 1,
  borderWidth: 1,
  color: theme.blue,
  fontFamily: theme.primaryFont,
  fontSize: '1.125rem',
  lineHeight: '0.89',
  padding: '20px 26px',
  textDecoration: 'none',
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': {
    boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.3)',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
  },
}

export const secondaryStyle = {
  backgroundColor: theme.yellow,
  border: 'solid',
  borderColor: theme.yellow,
  borderRadius: 1,
  borderWidth: 1,
  color: theme.darkerGrey,
  fontFamily: theme.primaryFont,
  fontSize: '1.125rem',
  lineHeight: '0.89',
  padding: '20px 26px',
  textDecoration: 'none',
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': {
    boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.3)',
    backgroundColor: theme.darkYellow,
  },
}

export const tertiaryStyle = {
  backgroundColor: theme.lightGrey,
  border: '1px solid',
  borderColor: theme.lightGrey,
  borderRadius: 1,
  borderWidth: 0,
  color: theme.textColor,
  fontFamily: theme.primaryFont,
  fontSize: '1.125rem',
  lineHeight: '0.89',
  padding: '20px 26px',
  textDecoration: 'none',
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': {
    boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.3)',
    backgroundColor: theme.lightGrey,
  },
}

export const transparentStyle = {
  backgroundColor: 'transparent',
  border: '1px solid white',
  borderRadius: 1,
  borderWidth: 1,
  color: 'white',
  fontFamily: theme.primaryFont,
  fontSize: '1.125rem',
  lineHeight: '0.89',
  padding: '20px 26px',
  textDecoration: 'none',
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': {
    boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.3)',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
  },
}

export const borderStyle = {
  backgroundColor: 'white',
  border: `1px solid ${theme.lightGrey}`,
  borderRadius: 1,
  borderWidth: 1,
  color: theme.blue,
  fontFamily: theme.primaryFont,
  fontSize: '1.125rem',
  lineHeight: '0.89',
  padding: '20px 26px',
  textDecoration: 'none',
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': {
    boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.3)',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
  },
  '&& .MuiTouchRipple-child': {
    opacity: '0.3',
  },
  '&& .MuiTouchRipple-childLeaving': {
    animationName: `$childLeaving`,
  },
  '@keyframes childLeaving': {
    '0%': {
      opacity: 0.2,
    },
    '100%': {
      opacity: 0,
    },
  },
}
